module.exports = __webpack_public_path__ + "media/images/iconTrendDown__accent--dark-44691fb996f0bfa3ab6cea494d2585cb.png";